import {createSelector} from '@reduxjs/toolkit'

const notEligibleSelector = createSelector(
    [state => state.components],
    ({notEligible}) => {
        return notEligible
    }
)

export const notEligibleSelect = state => ({
    notEligible: notEligibleSelector(state)
})